export const REDIRECT_DELAY = 2000;
